import m, {Vnode} from "mithril";
import {Naja} from "naja";

/**
 * Collect and manage files to be uploaded
 */
export default class UploadedFilesComponent {

    private readonly files: File[] = [];
    private readonly objectUrls: {[file_name: string]: string}= {}


    public addFiles(files: File[]): void {
        files.forEach((file: File) => {
            if (this.files.some(f => f.name === file.name)) {
                return;
            }

            this.files.push(file);

            if (file.size < 4_000_000 && ['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(this.getExtension(file))) {
                this.objectUrls[file.name] = URL.createObjectURL(file);
            }
        });

        m.redraw();
    }

    public getFiles(): File[] {
        return this.files;
    }

    public removeFile(file: File): void {
        const index = this.files.indexOf(file);
        if (index !== -1) {
            this.files.splice(index, 1);
            delete this.objectUrls[file.name];
        }
    }

    private getExtension(file: File): string {
        return file.name.split('.').pop().toLowerCase();
    }

    private viewIcon(file: File): Vnode {
        if (this.objectUrls[file.name]) {
            return m('img.UploadedFilesComponent-image', {
                src: this.objectUrls[file.name],
                alt: file.name,
                title: file.name,
            });
        }

        const ext = this.getExtension(file);

        const icon = {
            csv: 'filetype-csv',
            doc: 'filetype-doc',
            docx: 'filetype-docx',
            gif: 'filetype-gif',
            jpg: 'filetype-jpg',
            jpeg: 'filetype-jpeg',
            json: 'filetype-json',
            heic: 'filetype-heic',
            html: 'filetype-html',
            mp3: 'filetype-mp3',
            pdf: 'filetype-pdf',
            png: 'filetype-png',
            ppt: 'filetype-ppt',
            pptx: 'filetype-pptx',
            svg: 'filetype-svg',
            txt: 'filetype-txt',
            xlsx: 'filetype-xlsx',
            xls: 'filetype-xsl',
            xml: 'filetype-xml',
        }[ext] ?? 'file-earmark';

        return m('i.p-2.bi.bi-'+icon, {
            title: ext.toUpperCase(),
        });
    }

    /**
     * Rewrite standard ajax submit of form
     * Call this method on demand
     */
    public async send(form: HTMLFormElement, filesKey: string, naja: Naja): Promise<void> {

        const formData = new FormData();

        Array.from(form.elements).forEach((el: any) => {
            if (typeof el.name === 'string' && el.value !== undefined && el.name !== filesKey) {
                formData.append(el.name, el.value);
            }
        })

        this.getFiles().forEach((file: File) => {
            formData.append(filesKey, file);
        })

        try {
            const payload = await naja.makeRequest('POST', form.action, formData);
            // Naja, what's wrong with you!!!
            if (payload.forceRedirect) {
                window.location.href = payload.forceRedirect;
            }
        } finally {
            m.redraw();
        }
    }


    private viewFile(file: File): Vnode {
        return m('.UploadedFilesComponent-file.d-flex.position-relative.align-items-center.border', {}, [
            this.viewIcon(file),
            m('.UploadedFilesComponent-file-name.d-inline-block.p-2', {}, file.name),
            m('span.UploadedFilesComponent-file-removeButton.cursor-pointer.position-absolute.top-0.start-100.translate-middle.p-2.bg-danger.border.border-light.rounded-circle', {
                onclick: () => this.removeFile(file),
            }, '×')
        ]);
    }

    view(): Vnode|null {
        if (this.files.length === 0) {
            return null;
        }
        return m('.UploadedFilesComponent.d-flex.flex-wrap.gap-2', {}, this.files.map(f => this.viewFile(f)));
    }

}
